module.exports = __webpack_public_path__ + "img/wait_confirm.78648a01.svg";